import React from "react";

import { Destination, ErrorView } from "../../views/ErrorView";
import { LoadingView } from "../../views/LoadingView";
import { useParams } from "react-router-dom";
import { hasUnansweredQuestions, RoomState, useRoomData } from "../model/Room";
import { QuestionsView } from "./QuestionsViewJeopardy";
import { QuestionView } from "./QuestionViewJeopardy";
import { GameOverView } from "./GameOverViewJeopardy";
import { LobbyView } from "./LobbyViewJeopardy";

interface RouteParams {
  roomId: string;
}

export const PlayView: React.FC = () => {
  //console.log("PlayView");
  const { roomId } = useParams<RouteParams>();

  const { isLoading, error, game, room } = useRoomData(roomId);

  if (isLoading) {
    return <LoadingView />;
  }

  if (error || !room || !game) {
    return <ErrorView error={error || new Error("Room not found")} destination={Destination.JEOPARDY} />;
  }

  if (room.state === RoomState.LOBBY) {
    return <LobbyView game={game} room={room} />;
  }

  if (room.activeQuestionId) {
    return <QuestionView room={room} game={game} question={room.questions[room.activeQuestionId]} />;
  }

  if (!hasUnansweredQuestions(room, game)) {
    return <GameOverView game={game} room={room} />;
  }

  return <QuestionsView game={game} room={room} />;
};
